/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'project-actions.project-content.archive-error-title': 'Não foi possível restaurar o projeto',
  'project-actions.project-content.archive-project': 'Arquivar projeto',
  'project-actions.project-content.archive-restore-error-description':
    'Não foi possível salvar as alterações do projeto. Tente de novo mais tarde.',
  'project-actions.project-content.copy-project': 'Copiar projeto',
  'project-actions.project-content.copy-project.cancel': 'Cancelar',
  'project-actions.project-content.copy-project.close-modal': 'Fechar modal',
  'project-actions.project-content.copy-project.error': 'Dê um nome ao projeto para que todos saibam do que se trata',
  'project-actions.project-content.copy-project.failed-description':
    'Houve um erro ao clonar o projeto. Tente de novo mais tarde.',
  'project-actions.project-content.copy-project.failed-description-forbidden':
    'Você não tem permissão para copiar este projeto.',
  'project-actions.project-content.copy-project.failed-title': 'Não foi possível clonar este projeto.',
  'project-actions.project-content.copy-project.followers': 'Seguidores',
  'project-actions.project-content.copy-project.include': 'Incluir',
  'project-actions.project-content.copy-project.links': 'Links',
  'project-actions.project-content.copy-project.project-name': 'Nome do projeto',
  'project-actions.project-content.copy-project.submit': 'Enviar',
  'project-actions.project-content.copy-project.success-description': 'O projeto foi clonado.',
  'project-actions.project-content.copy-project.success-link': 'Ver projeto clonado.',
  'project-actions.project-content.copy-project.success-title': 'O Projeto {projectName} foi clonado.',
  'project-actions.project-content.copy-project.title': 'Copiar projeto',
  'project-actions.project-content.follow': 'Seguir',
  'project-actions.project-content.follow-confirmation-description':
    'A gente vai enviar um resumo contendo as atualizações de todos os projetos que você está acompanhando todas as manhãs de segunda-feira. Por que segundas-feiras? <a>Leia aqui</a>.',
  'project-actions.project-content.follow-error-title': 'Não foi possível seguir o projeto',
  'project-actions.project-content.follow-unfollow-error-description':
    'Não foi possível salvar as alterações do projeto. Tente de novo mais tarde.',
  'project-actions.project-content.restore-project': 'Restaurar projeto',
  'project-actions.project-content.share': 'Compartilhar',
  'project-actions.project-content.unfollow': 'Deixar de seguir',
  'project-actions.project-content.unfollow-error-title': 'Não foi possível deixar de seguir o projeto',
};
